import DashboardLayout from "../pages/Dashboard/Layout/DashboardLayout";

import Freight from '../pages/Purchases/Freight'
import Quotations from '../pages/Purchases/Quotations'
import PurchaseOrderTracking from '../pages/Purchases/PurchaseOrderTracking/index'
import Advances from '../pages/Purchases/Advances/index'
import InputFromPurchaseOrder from '../pages/Purchases/InputFromPurchaseOrder/index'
import PurchaseReport from '../pages/Purchases/Report'
import QuotationsSupplies from "../pages/Purchases/QuatationsSupplies/Index";
import QuotesTracking from "../pages/Purchases/QuotesTracking/index";

const purchasesPages = {
  path: "/",
  component: DashboardLayout,
  name: "PurchasesPages",
  title: "Compras",
  icon: "shopping_cart",
  excludedGroups: ["Extranet"],
  excludedRoles: ["IDEAL"],
  children: [
    {
      path: "/cotizaciones",
      name: "Cotizaciones",
      component: Quotations,
      meta: {
        ifUserCan: {
          view: "Materials_Quotation/materialsquotation",
        },
      },
    },
    {
      path: "/cotizacion",
      name: "Generar cotización",
      title: "Generar cotización de insumos",
      component: QuotationsSupplies,
      meta: {
        ifUserCan: {
          add: "Materials_Quotation/materialsquotationsupply",
          view: "PurchaseRequisition/consolidatedsupply"
        },
      },
    },
    {
      path: "/seguimiento_de_cotizaciones",
      name: "Seguimiento de cotizaciones",
      title: "Seguimiento de cotizaciones",
      component: QuotesTracking,
      meta: {
        ifUserCan: {
          view: "Materials_Quotation/authorizationmatrixforquotation",
        },
      },
    },
    // ! DEPRECATED
    // {
    //   path: "/generar_ordern_de_compra",
    //   name: "Generar orden de compra",
    //   title: "Generar orden de compra",
    //   component: Consolidated,
    //   meta: {
    //     ifUserCan: {
    //       add: "PurchaseRequisition/buyorderspackage",
    //     },
    //   },
    // },
    {
      path: "/seguimiento_de_compras",
      name: "Seguimiento de compras",
      title: "Seguimiento de compras",
      component: PurchaseOrderTracking,
      meta: {
        ifUserCan: {
          view: "PurchaseRequisition/buyorderspackage",
        },
      },
    },
    {
      path: "/anticipos",
      name: "Anticipos",
      title: "Anticipos",
      component: Advances,
      meta: {
        ifUserCan: {
          view: "PurchaseRequisition/advances",
        },
      },
    },
    {
      path: "/warehouse/input",
      name: "Entradas de material",
      title: "Entradas de material",
      component: InputFromPurchaseOrder,
      meta: {
        ifUserCan: {
          view: "IWarehouse/iwarehousemovement",
        },
      },
    },
    {
      path: "/fletes",
      name: "Fletes",
      title: "Fletes",
      component: Freight,
      meta: {
        ifUserCan: {
          view: "Freight/freight",
        },
      },
    },
    {
      path: "/compras/reporte",
      name: "Reporte Compras",
      title: "Reporte Compras",
      component: PurchaseReport,
      meta: {
        ifUserCan: {
          download_purchasereport: "PurchaseRequisition/purchaserequisition",
        },
      },
    },
  ],
};

export default purchasesPages;



// WEBPACK FOOTER //
// ./src/router/purchaseRoutes.js